import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { EMPTY_STRING } from '../../constants/constant';
import { appInsights } from '../../telemetry/appInsights';
import { APP_INSIGHTS_SEVERITY } from '../../constants/telemetryConstants';

interface Props {
  readonly children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    Sentry.captureException(error, {
      tags: { source: 'react-error-boundary' },
      extra: { componentStack: info.componentStack ?? EMPTY_STRING },
    });

    appInsights.trackException({
      exception: error,
      properties: {
        componentStack: info.componentStack ?? EMPTY_STRING,
        errorMessage: error.message,
        errorName: error.name,
        errorStack: error.stack ?? EMPTY_STRING,
      },
      severityLevel: APP_INSIGHTS_SEVERITY.ERROR,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
